<template>
  <div class="profile__item-container">
    <div
      id="password"
      :class="['profile__item', canEdit && 'profile__item--opened']"
      @click="toggleUpdateSection()"
    >
      <div class="profile__icon-wrapper">
        <KeyIcon size="1x" class="profile__icon" />
      </div>
      <div class="profile__item-data-wrapper">
        <p class="profile__item-lead">Password</p>
        <p class="profile__item-data">********</p>
      </div>
      <div
        :class="[
          'dashboard__action-icon',
          'btn',
          'btn--secondary',
          'btn--training-xsmall',
          canEdit && 'dashboard__action-icon--hide',
        ]"
      >
        <Edit2Icon />
      </div>
    </div>
    <transition name="longfade">
      <div v-if="isUpdatingSectionOpened" class="profile__item-edit-wrapper">
        <section v-if="!isLoading" class="ine-form">
          <ProfileUpdatePasswordForm
            @toggle-update-section="toggleUpdateSection()"
            :isLoading="isLoading"
            @submit-form="submitForm"
            :saveButtonDisabled="isSaveDisabled"
            :isUpdatingSectionOpened="isUpdatingSectionOpened"
          />
        </section>
        <section v-else class="profile__item-action-wrapper">
          <ActionLoader name="ball-clip-rotate" />
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import { KeyIcon, Edit2Icon } from 'vue-feather-icons'
import ProfileUpdatePasswordForm from '@/components/forms/ProfileUpdatePasswordForm.vue'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'ProfilePasswordUpdate',
  components: {
    ProfileUpdatePasswordForm,
    KeyIcon,
    Edit2Icon,
    ActionLoader,
  },
  data() {
    return {
      isLoading: false,
      editData: false,
      isSaveDisabled: true,
    }
  },
  props: {
    canEdit: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  watch: {
    selectedMFAMethod: {
      handler: 'updatePasswordTyped',
    },
  },
  methods: {
    async submitForm({ currentPassword, password }) {
      this.isLoading = true
      await this.$store.dispatch('auth/updateUserPassword', {
        currentPassword,
        password,
      })
      this.isLoading = false
    },
    updatePasswordTyped() {
      if (this.isUpdatingSectionOpened) this.isSaveDisabled = false
    },
    toggleUpdateSection() {
      this.$emit('itemActive', 'password')
      this.editData = !this.isUpdatingSectionOpened
      if (this.isUpdatingSectionOpened) this.$emit('itemActive', '')
    },
  },
  computed: {
    isUpdatingSectionOpened() {
      return this.canEdit && this.editData
    },
  },
}
</script>
